<template>
    <div v-if="hasSegments" class="journey">
        <Detailed v-if="showDetailed" :segments="segments" :type="data.type" />
        <Minified
            v-else
            :segments="segments"
            :company="data.company"
            :time="data.time"
            :type="data.type" />
    </div>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { computed, defineComponent, PropType } from 'vue';
    import { Journey } from './Journey.interfaces';
    import { isEmpty } from 'lodash';
    import Detailed from './Variants/Detailed.vue';
    import Minified from './Variants/Minified.vue';

    export default defineComponent({
        name: 'Journey',
        methods: { t },
        components: {
            Detailed,
            Minified,
        },
        props: {
            showDetailed: {
                type: Boolean,
                default: false,
            },
            data: {
                type: Object as PropType<Journey>,
                required: true,
            },
        },
        setup(props) {
            const segments = computed(() => props.data?.segments ?? []);
            const hasSegments = computed(() => !isEmpty(segments.value));

            return {
                segments,
                hasSegments,
            };
        },
    });
</script>
